import { useState, useEffect } from 'react';
import DashboardLayout from '../../components/layout/DashboardLayout';
import { useAuth } from '../../context/AuthContext';
import api from '../../utils/api';

export default function TutorProfileEdit() {
  const { user } = useAuth();
  const [bio, setBio]             = useState('');
  const [qualifications, setQuals] = useState('');
  const [notice, setNotice]       = useState(24);
  const [avatar, setAvatar]       = useState(null);
  const [saving, setSaving]       = useState(false);
  const [msg, setMsg]             = useState('');
  const [loading, setLoading]     = useState(true);

  useEffect(() => {
    api.get('/tutors/dashboard').then(r => {
      if (r.data.tutor) {
        setBio(r.data.tutor.bio || '');
        setQuals(r.data.tutor.qualifications || '');
        setNotice(r.data.tutor.notice_period_hours || 24);
      }
    }).finally(() => setLoading(false));
  }, []);

  const save = async () => {
    setSaving(true); setMsg('');
    try {
      const fd = new FormData();
      fd.append('bio', bio);
      fd.append('qualifications', qualifications);
      fd.append('notice_period_hours', notice);
      if (avatar) fd.append('avatar', avatar);
      await api.put('/tutors/profile', fd, { headers:{'Content-Type':'multipart/form-data'} });
      setMsg('success:Profile updated successfully');
    } catch(err) { setMsg('error:' + (err.response?.data?.message||'Failed')); }
    setSaving(false);
  };

  if (loading) return <DashboardLayout title="Edit Profile"><div className="loading-screen"><div className="spinner"/></div></DashboardLayout>;

  return (
    <DashboardLayout title="Edit Profile">
      <div style={{maxWidth:600}}>
        <div className="card">
          {msg && <div className={'alert ' + (msg.startsWith('success')?'alert-success':'alert-error')} style={{marginBottom:16}}>{msg.replace(/^(success|error):/,'')}</div>}

          <div className="form-group">
            <label className="form-label">Profile photo</label>
            <div style={{display:'flex',gap:16,alignItems:'center'}}>
              <div className="avatar-placeholder avatar-lg" style={{fontSize:'1.2rem'}}>
                {user?.first_name?.[0]}{user?.last_name?.[0]}
              </div>
              <div>
                <input type="file" accept="image/*" onChange={e=>setAvatar(e.target.files[0])} style={{fontSize:'0.82rem'}}/>
                <p style={{fontSize:'0.75rem',color:'var(--ink-400)',margin:'4px 0 0'}}>JPG or PNG, max 5MB</p>
                {avatar && <p style={{fontSize:'0.78rem',color:'var(--green-700)',margin:'4px 0 0'}}>✓ {avatar.name}</p>}
              </div>
            </div>
          </div>

          <div className="form-group">
            <label className="form-label">Bio</label>
            <textarea className="form-textarea" rows={6} value={bio} onChange={e=>setBio(e.target.value)}
              placeholder="Tell parents about your teaching experience and approach..."/>
            <div style={{fontSize:'0.75rem',color:'var(--ink-300)',textAlign:'right'}}>{bio.length} characters</div>
          </div>

          <div className="form-group">
            <label className="form-label">Qualifications</label>
            <textarea className="form-textarea" rows={4} value={qualifications} onChange={e=>setQuals(e.target.value)}
              placeholder="List your degrees, teaching qualifications, certifications..."/>
          </div>

          <div className="form-group">
            <label className="form-label">Minimum booking notice</label>
            <select className="form-select" value={notice} onChange={e=>setNotice(parseInt(e.target.value))}>
              <option value={24}>24 hours</option>
              <option value={48}>48 hours</option>
              <option value={72}>72 hours</option>
            </select>
          </div>

          <div style={{display:'flex',gap:12,alignItems:'center',flexWrap:'wrap'}}>
            <button className="btn btn-primary" onClick={save} disabled={saving}>
              {saving ? 'Saving...' : 'Save profile'}
            </button>
            <a href={'/tutor/' + user?.slug} target="_blank" rel="noopener noreferrer" className="btn btn-ghost btn-sm">
              View public profile
            </a>
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
}
